import { render, staticRenderFns } from "./ViewFunnel.vue?vue&type=template&id=460f811c"
import script from "./ViewFunnel.vue?vue&type=script&lang=js"
export * from "./ViewFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports